import { render, staticRenderFns } from "./ChangeCategory.vue?vue&type=template&id=36e133d7&"
import script from "./ChangeCategory.vue?vue&type=script&lang=js&"
export * from "./ChangeCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports